import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'caricoRidottoPipe' })
export class CaricoRidottoPipe implements PipeTransform {

    transform(inputValue: number): string {

        var rispostaAlPipe = "Valore inesistente";


        switch(inputValue){

            case 1:
            {
                rispostaAlPipe = "SI";
            }
            break;

            case 2:
            {
                rispostaAlPipe = "NO";
            }
            break;

        }

        return rispostaAlPipe; 

    }

}

@Pipe({ name: 'sospensioneDidatticaPipe' })
export class SospensioneDidatticaPipe implements PipeTransform {

    transform(inputValue: number): string {

        var rispostaAlPipe = "Valore inesistente";


        switch(inputValue){

            case 1:
            {
                rispostaAlPipe = "Ha usufruito";
            }
            break;

            case 2:
            {
                rispostaAlPipe = "Non ha usufruito";
            }
            break;

        }

        return rispostaAlPipe; 

    }

}

@Pipe({ name: 'passaggioRuoloPipe' })
export class PassaggioRuoloPipe implements PipeTransform {

    transform(inputValue: number): string {

        var rispostaAlPipe = "Valore inesistente";


        switch(inputValue){

            case 1:
            {
                rispostaAlPipe = "Nessuna assunzione/passaggio di ruolo";
            }
            break;

            case 2:
            {
                rispostaAlPipe = "Assunzione come ricercatore di tipo A";
            }
            break;

            case 3:
            {
                rispostaAlPipe = "Assunzione come ricercatore di tipo B";
            }
            break;

            case 4:
            {
                rispostaAlPipe = "Passaggio ricercatore associato";
            }
            break;

            case 5:
            {
                rispostaAlPipe = "Passaggio associato ordinario";
            }
            break;

            case 6:
            {
                rispostaAlPipe = "Altro";
            }
            break;

        }

        return rispostaAlPipe;

    }

}